const DomUtils = {
    /**
     * Hides an element by adding the class "hide" and then "hidden" after the
     * transition is finished. The element must have a transition set in CSS.
     *
     * @param {number} duration
     * @param {() => void} callback
     *
     * @this {Element}
     */
    hide(duration = 400) {
        return new Promise((resolve) => {
            this.classList.add('hide');

            setTimeout(() => {
                this.classList.add('hidden');
                resolve();
            }, duration);
        });
    },
};

Element.prototype.hide = DomUtils.hide;

/**
 * @typedef {DomUtils & Element} DomElement
 */

/**
 * @param {string} selector
 * @returns {DomElement|null}
 */
export const get = (selector) => document.querySelector(selector);

/**
 * @param {string} selector
 * @returns {NodeListOf<DomElement>}
 */
export const all = (selector) => document.querySelectorAll(selector);

export function onDomReady(callback) {
    try {
        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', callback);
        } else {
            callback();
        }
    } catch {
        document.body.classList.replace('loading', 'loaded');
    }
}
